import { _getFeedbackRatings } from "../constants/api";

export const getAllFeedbacks = async () => {
  try {
    
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_getFeedbackRatings}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    const responseJSON = await response.json();
    return responseJSON;

  } catch (error) {
    console.log('Error occurred in the getAllUsers API ==> ', error);
  }
};

export const getFeedbackByMonthWise = async (body) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    // Add the month and year as query parameters to the URL
    const { month, year } = body;
    const response = await fetch(`${_getFeedbackRatings}/monthly-rating?month=${month}&year=${year}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    const responseJSON = await response.json();
    return responseJSON;
  } catch (error) {
    console.log('Error occurred in the getFeedbackByMonthWise API ==> ', error);
  }
};
